import { render, staticRenderFns } from "./d-upvote-book-activity.vue?vue&type=template&id=5d5d5c82&"
import script from "./d-upvote-book-activity.vue?vue&type=script&lang=js&"
export * from "./d-upvote-book-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports